import { render } from "./ComplianceConsult.vue?vue&type=template&id=cf863edc&scoped=true"
import script from "./ComplianceConsult.vue?vue&type=script&lang=js"
export * from "./ComplianceConsult.vue?vue&type=script&lang=js"

import "./ComplianceConsult.vue?vue&type=style&index=0&id=cf863edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf863edc"]])

export default __exports__